// KamuoyunaDuyuru.js
import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { FaPhone, FaEnvelope, FaInstagram, FaExclamationTriangle } from "react-icons/fa";

const KamuoyunaDuyuru = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Duyuru her oturumda bir kez gösterilir; kullanıcı kapattıktan sonra
    // aynı oturum içinde tekrar rahatsız etmez.
    const gorulduMu = sessionStorage.getItem("kamuoyunaDuyuruGoruldu");
    if (!gorulduMu) {
      setVisible(true);
    }
  }, []);

  const onHide = () => {
    sessionStorage.setItem("kamuoyunaDuyuruGoruldu", "true");
    setVisible(false);
  };

  const dialogWidth = window.innerWidth < 768 ? "92vw" : "38vw";

  const header = (
    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
      <FaExclamationTriangle color="#d9534f" size={22} />
      <span style={{ fontWeight: "bold", letterSpacing: "0.5px" }}>
        KAMUOYUNA DUYURU
      </span>
    </div>
  );

  const footer = (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Button
        label="Okudum, Anladım"
        onClick={onHide}
        style={{ backgroundColor: "#f96332", border: "none", color: "#fff" }}
      />
    </div>
  );

  const linkStyle = {
    color: "#343a40",
    textDecoration: "none",
    fontWeight: "600",
  };

  return (
    <Dialog
      header={header}
      visible={visible}
      onHide={onHide}
      footer={footer}
      style={{ width: dialogWidth }}
      breakpoints={{ "768px": "92vw" }}
      dismissableMask
    >
      <div style={{ fontSize: "0.95rem", color: "#343a40", lineHeight: "1.6" }}>
        <p>
          Son günlerde bazı kişilere, <strong>ARS HUKUK</strong> adı kullanılarak
          çeşitli SMS ve iletişim mesajları gönderildiği öğrenilmiştir.
        </p>
        <p>
          Hukuk büromuz adına gerçekleştirilecek tüm bilgilendirme ve iletişim,
          yalnızca resmî kanallarımız üzerinden yapılmaktadır. Bu nedenle aşağıdaki
          numaralar dışındaki iletişimlerin ofisimizle ilişkilendirilmemesini önemle
          rica ederiz.
        </p>
        <p>Kamuoyuna saygıyla duyurulur.</p>

        <hr style={{ margin: "1rem 0" }} />

        <p style={{ fontWeight: "bold", marginBottom: "0.75rem" }}>
          Resmî İletişim Bilgilerimiz
        </p>
        <div style={{ display: "flex", flexDirection: "column", gap: "0.5rem" }}>
          <div>
            <FaPhone color="#007bff" />{" "}
            <a href="tel:05402770001" style={linkStyle}>
              0540 277 00 01
            </a>
          </div>
          <div>
            <FaEnvelope color="#007bff" />{" "}
            <a href="mailto:iletisim@arshukukburosu.com" style={linkStyle}>
              iletisim@arshukukburosu.com
            </a>
          </div>
          <div>
            <FaInstagram color="#E1306C" />{" "}
            <a
              href="https://www.instagram.com/ars.hukukburosu"
              target="_blank"
              rel="noopener noreferrer"
              style={linkStyle}
            >
              @ars.hukukburosu
            </a>
          </div>
        </div>
      </div>
    </Dialog>
  );
};

export default KamuoyunaDuyuru;
